var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areyouin"},[_c('div',{staticClass:"title"},[_vm._v("您的企业是否还经历着")]),_c('div',{staticClass:"list"},_vm._l((_vm.arr),function(item){return _c('TroubleCard',{key:item.title,attrs:{"title":item.title,"logo":item.logo,"desc":item.desc}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }